/**
 * @author liyuan <yuankylee@163.com>
 * @desc api urls
 * @date 2021/08/03
 */

export const api = {
  PARTNER_LIST: "/changer/v9/index/manage/partner/list", //官网合作伙伴
  GET_FILLRE_VIEW: "/carbonfootprint/v8/carbonFootQrCodeNew/getFillReview/", //访问次数
  CARBON_FOOTQRCODE_REDUCTION:
    "/carbonfootprint/v8/carbonFootQrCodeReduction/getFillReview/", //碳减排
  GET_FILLREVIEW: "/carbonneutralitypublish/v8/pubEmission/getFillReview",
  GET_NEUTRALITY_FILLREVIEW:
    "/carbonneutralitypublish/v8/neutrality/getFillReview",
  // PARTNER_LIST: '/changer/v9/index/manage/partner/list', //官网合作伙伴
  // GET_FILLRE_VIEW:'/carbonfootprint/v8/carbonFootQrCodeNew/getFillReview/', //访问次数
  // CARBON_FOOTQRCODE_REDUCTION:'/carbonfootprint/v8/carbonFootQrCodeReduction/getFillReview/', //碳减排
  VISIT_H5: "/carbonfootprint/v8/visit/h5/", //访问次数
  DATA_CENTER_VISIT_H5: "/data-center/v8/visit/h5/", //数据中心访问次数
  MODULAR_USER_VISIT_H5: "/modularity-user/v8/carbonCompare/visit/h5/", // 减排对比结果访问次数
  FOOT_FILTER_LNG: "/cloud/v8/foot/filter/lng/", //获取当前设置的中英文
  GET_WX_CONFIG: "/carbonneutralitypublish/v8/wechat/authorization", // 获取微信配置
  GET_FILL_REVIEW: "/data-center/v8/carbonFootQrCode/getFillReview/", // 碳足迹Demo报告数据根据code码追溯
  GET_FILL_REVIEWBASE:
    "/modularity-user/v8/reductionContrastQrCode/getFillReviewBase/", // 减碳h5产品详情
  FUXI_V8_DIGITAL_ELE_CH: "/fuxi/v8/digital/ele/ch", // 碳足迹Demo报告数据根据code码追溯中文
  FUXI_V8_DIGITAL_ELE_EN: "/fuxi/v8/digital/ele/en", // 碳足迹Demo报告数据根据code码追溯英文
  LCA_CARBON_FOOTQRCODE_REDUCTION:
    "/modularity-user/v8/reductionContrastQrCode/getFillReview/", //碳减排对比
  LCA_CARBON_REDUCTION_DETAIL:
    "/modularity-user/v8/reductionContrastQrCode/getStage/", // 碳减排对比详情
  DATA_CENTER_UPCHAIN_INFO: "/data-center/v8/carbonFootQrCode/up/chain/", // 区块链证书-查询
  MODULARITY_USER_UPCHAIN_INFO:
    "/modularity-user/v8/reductionContrastQrCode/up/chain/", // 区块链证书-查询
  CLOUDN_UPCHAIN_INFO: "/cloud/v8/foot/upchain/log/info/", // 区块链证书-查询
  DATA_CENTER_GET_FILL_REVIEW: "/data-center/v8/gf/getFillReview/", //xxx
};

/**
 * Simplify the rest parameters creation, e.g:
 * //NOTICE: order of params in array is important, params use object do not care about order
 * formatRestfulUrl('/user/:id/:id2', [1,2]) ->  /user/1/2
 * formatRestfulUrl('/user/:id/:id2', {id2: 2, id: 1}) ->  /user/1/2
 * @param {string} url request url definition
 * @param {Array|Object} params rest parameters
 * @return {*}
 */
export const formatRestfulUrl = function (url, params) {
  if (!params || url.indexOf(":") < 0) return url;
  let parts = url.split("/");
  let partIndex = 0;
  const isArray = Array.isArray(params);
  parts.forEach(function (ele, index) {
    if (ele.indexOf(":") === 0) {
      parts[index] = isArray ? params[partIndex] : params[ele.substring(1)];
      partIndex++;
    }
  });
  return parts.join("/");
};

/**
 * Check the number of rest params in the current url definition
 * @param url
 * @return {number}
 */
export const numberOfRestParams = function (url) {
  const matched = url.match(/\/:/g);
  return matched ? matched.length : 0;
};
